import { Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MarketingPreferencesForm,
  MarketingPreferencesFormConfig,
  MarketingPreferencesFormField,
} from '@checkout/util-models';
import { FormControlValidators } from '@domgen/dgx-fe-forms/shared';
import { TranslateService } from '@domgen/dgx-fe-i18n';
import { FeatureMarketingPreferencesTranslationDictionary } from '../../models/i18n/feature-marketing-preferences-dictionary.interface';

@Injectable()
export class MarketingPreferencesFormBuilder {
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly translateService: TranslateService<FeatureMarketingPreferencesTranslationDictionary>
  ) {}

  build(
    config: MarketingPreferencesFormConfig
  ): FormGroup<MarketingPreferencesForm> {
    return this.formBuilder.group(this.buildFormConfig(config));
  }

  private buildFormConfig(
    config: MarketingPreferencesFormConfig
  ): MarketingPreferencesForm {
    const { initialValue } = config;

    return {
      [MarketingPreferencesFormField.MarketingPreferenceEmail]: new FormControl(
        initialValue?.marketingPreferenceEmail ?? null,
        Validators.compose([
          FormControlValidators.required(
            this.translateService.translate(
              'MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_EMAIL_ERROR_REQUIRED'
            )
          ),
        ])
      ),
      [MarketingPreferencesFormField.MarketingPreferenceTelephone]:
        new FormControl(
          initialValue?.marketingPreferenceTelephone ?? null,
          Validators.compose([
            FormControlValidators.required(
              this.translateService.translate(
                'MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_TELEPHONE_ERROR_REQUIRED'
              )
            ),
          ])
        ),
      [MarketingPreferencesFormField.MarketingPreferencePost]: new FormControl(
        initialValue?.marketingPreferencePost ?? null,
        Validators.compose([
          FormControlValidators.required(
            this.translateService.translate(
              'MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_POST_ERROR_REQUIRED'
            )
          ),
        ])
      ),
    };
  }
}
